module.exports = __webpack_public_path__ + "img/offer.207fb40.jpg";